const TOKEN_KEY = 'hiwa_admin_token';
const USER_KEY = 'hiwa_admin_user';

export const getToken = () => sessionStorage.getItem(TOKEN_KEY);

export const setAuth = (token, user) => {
  sessionStorage.setItem(TOKEN_KEY, token);
  if (user) {
    sessionStorage.setItem(USER_KEY, JSON.stringify(user));
  }
};

export const getAdminUser = () => {
  const raw = sessionStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const clearAuth = () => {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);
};

export const isAuthenticated = () => Boolean(getToken());
